/**
 * Generated by orval v7.11.2 🍺
 * Do not edit manually.
 * BFF API
 * OpenAPI spec version: 1.0
 */

/**
 * Whether the damage is still open (CREATED) or has been closed (FIXED).
 */
export type DamageDtoStatus = typeof DamageDtoStatus[keyof typeof DamageDtoStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DamageDtoStatus = {
  CREATED: 'CREATED',
  FIXED: 'FIXED',
} as const;
